export default __webpack_public_path__ + "static/media/rebet.4ea5fe37.mp3";